import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const SectionWrapper = styled.div`
  padding: 175px 0 175px;
  overflow: hidden;
  @media only screen and (max-width: 1440px) {
    padding: 175px 0 125px;
  }
  @media only screen and (max-width: 1099px) {
    padding: 125px 0 125px;
  }
  @media only screen and (max-width: 768px) {
    padding: 75px 0;
  }
  @media only screen and (max-width: 480px) {
    padding: 75px 0 50px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media only screen and (max-width: 1099px) {
    flex-direction: column;
    justify-content: center;
  }
  .image {
    width: calc(100% - 493px);
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding-bottom: 100px;
    margin-right: 100px;
    @media only screen and (max-width: 1099px) {
      width: 100%;
      justify-content: space-around;
      margin-right: 0;
      padding-bottom: 70px;
      left: 10%;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 20px;
      left: 8%;
    }
    @media only screen and (max-width: 480px) {
      left: 0%;
      padding-bottom: 20px;
    }

    .item_wrapper {
      position: absolute;

      cursor: pointer;
      @media only screen and (max-width: 1099px) {
        position: relative;
        width: 33%;
        height: 200px;
      }
      @media only screen and (max-width: 480px) {
        width: 40%;
      }
      img {
        &:hover {
          box-shadow: 0px 20px 57px 0px rgba(57, 81, 111, 0.28);
          @media only screen and (max-width: 1099px) {
            box-shadow: none;
          }
        }
      }
      &:nth-child(1) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          top: -260px;
          right: 200px;
        }
      }
      &:nth-child(2) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          top: -40px;
          left: -25px;
        }
      }
      &:nth-child(3) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          right: 200px;
          top: -40px;
        }
      }
      &:nth-child(4) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          right: -45px;
          top: -260px;  
        }
      }
      &:nth-child(5) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          top: -40px;
          right: -45px;
        }
      }
      &:nth-child(6) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          left: -25px;
          top: -260px;
        }
      }
      &:nth-child(7) {
        top: auto;
        left: auto;
        @media only screen and (min-width: 1220px) {
          top: 160px;
          right: 45px;
        }
      }
     &:nth-child(8) {
      top: auto;
      left: auto;
        @media only screen and (min-width: 1220px) {
          top: 160px;
          right: 300px;
        }
      }
     &:nth-child(9) {
        top: 50px;
        left: 25px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(10) {
        top: 20px;
        left: 265px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(11) {
        top: -170px;
        left: 450px;
        width: 20%;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(12) {
        top: -70px;
        left: 0px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(13) {
        top: -100px;
        left: 250px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(14) {
        top: 135px;
        left: 450px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          left: auto;
        }
      }
     &:nth-child(15) {
        right: 105px;
        top: 25px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          right: auto;
        }
      }
     &:nth-child(16) {
        right: 405px;
        top: 175px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          right: auto;
        }
      }
     &:nth-child(17) {
        right: 305px;
        top: 65px;
        @media only screen and (max-width: 1099px) {
          top: auto;
          right: auto;
        }
      }
      .author_name {
        position: absolute;
        padding: 20px;
        top: -59px;
        left: 34px;
        background-color: rgb(209, 57, 124);
        box-shadow: 0px 16px 57px 0px rgba(57, 81, 111, 0.1);
        border-radius: 28px 28px 28px 0;
        width: 122%;
        text-align: center;
        opacity: 0;
        transition: all 0.35s ease;
        font-size: 16px;
        color: #fff;
        letter-spacing: -0.25px;
        font-weight: 500;
        @media only screen and (max-width: 1099px) {
          width: auto;
        }
        @media only screen and (max-width: 768px) {
          padding: 15px 30px;
        }

        &::before {
          content: '';
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 22px 19px 0 0;
          border-color: rgb(209, 57, 124) transparent transparent transparent;
          position: absolute;
          bottom: -22px;
          left: 0;
          @media only screen and (max-width: 1099px) {
            bottom: -18px;
          }
        }
      }
      .imageWrapper {
        border-radius: 50%;
        overflow: hidden;
        @media only screen and (max-width: 1099px) {
          border-radius: 0;
        }
      }
      &.active {
        z-index: 1;
        .author_name {
          opacity: 1;
        }
        .imageWrapper {
          box-shadow: 0px 20px 57px 0px rgba(57, 81, 111, 0.18);
          @media only screen and (max-width: 1099px) {
            box-shadow: none;
          }
        }
      }
      &:hover {
      }
    }
  }
  .content {
    width: 393px;
    @media only screen and (max-width: 1099px) {
      width: 100%;
    }
    @media only screen and (max-width: 991px) {
      width: 100%;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
      margin-top: -60px;
    }
    h2 {
      color: ${themeGet('colors.headingColor', '#0F2137')};
      font-size: 36px;
      line-height: 44px;
      font-weight: 700;
      letter-spacing: -1px;
      padding-right: 42px;
      margin-bottom: 27px;
      @media only screen and (max-width: 1366px) {
        font-size: 30px;
        line-height: 42px;
        margin-bottom: 20px;
      }
      @media only screen and (max-width: 991px) {
        font-size: 26px;
        line-height: 38px;
      }
    }
    p {
      font-size: 18px;
      line-height: 28px;
      color: #6e7379;
      margin-bottom: 36px;
      @media only screen and (max-width: 1366px) {
        margin-bottom: 30px;
      }
    }
  }
  .reusecore__button {
    border-radius: 5px;

    &:hover {
      box-shadow: #d1397c 0px 12px 24px -10px;
    }
  }
`;

export default SectionWrapper;
